import type { MapFeatureMapStyle } from '@gpx-spa/geo-domain'
import { ANT_PATH_DEFAULTS } from './constants.js'

/**
 * Resolved ant-path paint timing + colors for both Leaflet and Mapbox (from `properties.map`).
 */
export type ResolvedAntPathStyle = {
  lineColor: string
  lineWidth: number
  lineOpacity: number
  /** Leaflet `pulseColor`; Mapbox underlay line color. */
  pulseColor: string
  /** Leaflet `delay` (ms); Mapbox length of one full dash-sequence cycle (ms). */
  cycleMs: number
}

/**
 * Merges feature `map` fields with {@link ANT_PATH_DEFAULTS}. Use when `lineAntPath` is true.
 */
export function resolveAntPathStyle(
  map: Pick<
    MapFeatureMapStyle,
    'lineColor' | 'lineWidth' | 'lineOpacity' | 'lineAntPathDelay' | 'lineAntPathPulseColor'
  >
): ResolvedAntPathStyle {
  return {
    lineColor: map.lineColor ?? ANT_PATH_DEFAULTS.lineColor,
    lineWidth: map.lineWidth ?? ANT_PATH_DEFAULTS.lineWidth,
    lineOpacity: map.lineOpacity ?? ANT_PATH_DEFAULTS.lineOpacity,
    pulseColor: map.lineAntPathPulseColor ?? ANT_PATH_DEFAULTS.pulseColor,
    cycleMs: map.lineAntPathDelay ?? ANT_PATH_DEFAULTS.cycleMs,
  }
}
